<template>
<!-- 
  SETUP 2FA 
  FOR FIRST TIME LOGIN 
 -->
  <div class="auth-setup">
    <el-form ref="setupForm" :model="form" :rules="rules"
    v-loading="loading"
    element-loading-text="Submitting..."
    >
      <h4 class="text-center">IMPORTANT</h4>
      <p>As an office bearer we require additional security before you can access the member portal.</p>
      <p>You will only complete this registration process once, and will be required to use our two-factor authentication process each time you login after this.</p>
      <p>We have sent a text message to your mobile number ending in {{ phoneEnding }}. Please enter the 6 digit code from that message below:</p>
      <el-form-item label="Token" :inline-message="true" prop="token" class="token-input">
        <el-input v-model="form.token" size="medium" maxlength="6"/>
      </el-form-item>
      <span class="text-muted">Your token expires in 2 minutes</span>
      <p>If your mobile number does not end in {{ phoneEnding }}, please contact us on (02) 8356 0300</p>
      <p>If you forget your password you will be required to provide an answer to a security question. Please select a question and provide your answer.</p>
      <el-form-item :inline-message="true" prop="question" class="select-question">
        <el-select v-model="form.question" placeholder="Choose a security question?" size="medium">
          <el-option
            v-for="question in questions"
            :key="question.key"
            :label="question.value"
            :value="question.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :inline-message="true" prop="answer">
        <el-input v-model="form.answer" size="medium" />
      </el-form-item>
    </el-form>
    <el-alert v-if="error" title="Authentication failed" type="error" :description="error" show-icon></el-alert>
    <div class="form-action">
      <el-button type="primary" class="btn-confirm" :disabled="loading" @click="submitForm('setupForm')">Continue</el-button>
      <el-button type="text" @click="cancelLogIn">Cancel and return to login</el-button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  data() {
    return {
      form: {
        token: '',
        question: '',
        answer: ''
      },
      rules: {
        token: {
          required: true,
          message: "Token is required",
          trigger: "blur"
        },
        question: {
          required: true,
          message: "Security question is required",
          trigger: "change"
        },
        answer: {
          required: true,
          message: "Security question answer is required",
          trigger: "blur"
        }
      }
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      questions: state => state.auth.questions,
      loading: state => state.auth.loading,
      error: state => state.auth.error
    }),
    phoneEnding() {
      if (this.user) {
        return this.user.mobile.substring(this.user.mobile.length - 3);
      }
      
      return 'xxxx'
    }
  },
  methods: {
    ...mapActions('auth', ['cancelLogIn', 'twoFactorSetup']),
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (!valid) {
          return false;
        }

        await this.twoFactorSetup({
          "security_question": this.form.question,
          "security_answer": this.form.answer,
          "token_2fa": this.form.token
        });
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.auth-setup {
  h4 {
    text-align: center;
    margin-top: 0;
    margin-bottom: 1rem;
  }

  p {
    font-size: 0.925rem;
    line-height: 24px;
    margin-top: 0;
  }

  .el-form {
    .text-muted {
      display: inline-block;
      color: #606266;
      font-size: 0.825rem;
      font-style: italic;
      margin-bottom: 17px;
    }

    .el-alert {
      margin-bottom: 15px;
    }

    .el-form-item {
      margin-bottom: 10px!important;

      &.token-input {
        margin-bottom: 0px!important;
      }

      &.select-question {
        margin-bottom: 3px!important;
      }

      >>>.el-form-item__label {
        line-height: 22px;
        font-weight: bold;
      }

      >>>.el-form-item__content {
        .el-form-item__error {
          padding-top: 0;
          padding-bottom: 4px;
        }
      }
    }

    >>>.el-select {
      width: 100%;

      .el-input--medium {
        .el-input__suffix {
          height: 85%;
        }
      }
    }
  }

  .form-action {
    .btn-confirm {
      margin-top: 18px;
      font-weight: bold;
      font-size: 0.945rem;
      width: 100%;
      padding-top: 18px;
      padding-bottom: 18px;
    }

    .el-button--text {
      margin-left: 0;
      color: #67C23A;
      padding-top: 6px;
      padding-bottom: 0;

      &:hover {
        font-weight: bold;
      }
    }
  }
}
</style>
